<template>
  <centered-layout :showFooter="true">
    <status :stepStatuses="stepStatuses" @click="logout">
      <heading level="2" class="title" slot="title">{{
        $t('waitingForAdditionalOwners.title')
      }}</heading>
      <div class="description" slot="description">
        {{ $t('waitingForAdditionalOwners.description') }}
      </div>
      <span slot="buttonLabel">{{ $t('waitingForAdditionalOwners.button') }}</span>
    </status>
  </centered-layout>
</template>

<script>
import Status from '@/components/Status';
import CenteredLayout from '@/views/layouts/CenteredLayout';
import { COMPLETE, PENDING } from '@/constants/application-step-statuses';
import { mapActions } from 'vuex';
import applicationMixin from '@/mixins/application';
import { createNewThreatMetrixScript } from '@/analytics/threatmetrix';

export default {
  components: {
    CenteredLayout,
    Status,
  },
  mixins: [applicationMixin],
  data() {
    return {
      stepStatuses: [COMPLETE, COMPLETE, PENDING],
    };
  },
  async created() {
    if (this.application._extension.isBLASigned === undefined) {
      await this.updateThreatMetrixSessionId();
      createNewThreatMetrixScript();
      await this.$store.dispatch('application/fetchApplication');
      this.application._extension.isBLASigned = true;
      await this.updateApplication(this.generatePatch());
    }
  },
  methods: {
    ...mapActions('application', ['updateThreatMetrixSessionId']),
    async logout() {
      await this.$auth.logOut();
    },
  },
};
</script>
<style lang="sass" scoped></style>
